// leaf-town - the soundtrack. Every tune is written out here as notes.
// Melodies: one token per eighth note (u:2) unless noted. '-' holds, '.' rests, '|' is only for the eye.
// bass: chord degrees  arp: chord-tone indices  stab: rhythm of chord hits  drums: x hit, X accent, o ghost
(function () {
  'use strict';
  const S = (window.G.SONGS = {});

  // the main theme - the motif that comes back in the title, the final fight and the ending
  const THEME_A = `f#5 - a5 - d6 - c#6 a5 | b5 - a5 - e5 - - - | d5 - f#5 - b5 - a5 f#5 | g5 - f#5 - d5 - - - |
                   f#5 - a5 - d6 - e6 - | e6 - c#6 - a5 - b5 c#6 | d6 - b5 - g5 - b5 - | a5 - - - - - . .`;
  const THEME_B = `b4 - d5 - g5 - f#5 d5 | c#5 - e5 - a5 - g5 e5 | a4 - c#5 - f#5 - e5 c#5 | d5 - b4 - f#4 - - - |
                   b4 - d5 - g5 - a5 b5 | a5 - e5 - c#5 - e5 - | f#5 - d5 - a4 - d5 - | d5 - - - - - . .`;
  const CH_A = 'D | A/C# | Bm | G | D | A | G | A';
  const CH_B = 'G | A | F#m | Bm | G | A | D | D';

  const themeSections = {
    I: { bars: 4, chords: 'D | A/C# | Bm | G', pad: { pad: true }, twinkle: { arp: '0 2 3 2 4 2 3 2', u: 2, oct: 4, inst: 'glass', v: 0.7 } },
    A: {
      bars: 8, chords: CH_A, pad: { pad: true },
      bell: { n: THEME_A, inst: 'bell' },
      bass: { bass: '1 - - - . . 1 -', u: 2, v: 0.8 },
      twinkle: { arp: '0 . 2 . 3 . 2 .', u: 2, oct: 4, inst: 'glass', v: 0.45 },
    },
    A2: {
      bars: 8, chords: CH_A, pad: { pad: true },
      lead: { n: THEME_A, inst: 'soft' }, dbl: { n: THEME_A, inst: 'thin', v: 0.45 },
      bass: { bass: '1 . 1 . 5 . 1 8', u: 2 },
      arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 4, inst: 'chip', v: 0.7 },
      drums: { k: 'x.......x.x.....', r: '....x.......x...', h: 'x.x.x.x.x.x.x.x.' },
      fill: { r: '....x.....x.x.xx' },
    },
    B: {
      bars: 8, chords: CH_B, pad: { pad: true },
      lead: { n: THEME_B, inst: 'soft', oct: 1 }, dbl: { n: THEME_B, inst: 'thin', v: 0.4, oct: 1 },
      bass: { bass: '1 . 1 8 . 1 5 8', u: 2 },
      arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 4, inst: 'chip', v: 0.7 },
      drums: { k: 'x.....x.x.......', s: '....x.......x...', h: 'x.x.x.x.x.x.x.x.' },
      fill: { s: '....x.......xxxx', m: '........x.x.....' },
    },
  };
  S.title = { bpm: 100, sections: themeSections, order: ['I', 'A', 'A2', 'B', 'A2'], loop: 1 };
  S.ending = { bpm: 118, sections: themeSections, order: ['A2', 'B', 'A2', 'B'], loop: 0 };

  S.night = {
    bpm: 66,
    sections: {
      A: {
        bars: 4, chords: 'Dmaj7 | Bm7 | Gmaj7 | A', pad: { pad: true, v: 1.2 },
        twinkle: { arp: '0 . . 2 . . 3 . . . 2 . . . . .', u: 1, oct: 4, inst: 'glass', v: 0.6 },
        bell: { n: '. . . . f#5 - a5 - | d6 - - - - - . . | . . . . b5 - a5 - | e5 - - - - - . .', inst: 'bell', v: 0.8 },
        bass: { bass: '1 - - - - - - -', u: 2, inst: 'sub', v: 0.7 },
      },
    },
    order: ['A'], loop: 0,
  };

  S.map = {
    bpm: 104,
    sections: {
      A: {
        bars: 8, chords: 'G | D/F# | Em | C | G | D/F# | C | D',
        arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 4, inst: 'pluck', v: 0.9 },
        bass: { bass: '1 . . 1 . . 5 .', u: 2, v: 0.8 },
        bell: { n: `b5 - d6 - g6 - - - | a5 - d6 - f#6 - - - | g5 - b5 - e6 - d6 b5 | c6 - - - g5 - e5 - |
                    b5 - d6 - g6 - - - | a6 - f#6 - d6 - - - | e6 - c6 - g5 - c6 - | d6 - - - a5 - f#5 -`, inst: 'bell', v: 0.75 },
        pad: { pad: true, v: 0.8 },
        drums: { k: 'x.........x.....', r: '....x.......x...', h: '..x...x...x...x.' },
      },
    },
    order: ['A'], loop: 0,
  };

  // World 1 - The Source Tree: bright, bouncy, a little folksy
  S.w1 = {
    bpm: 132,
    sections: {
      I: {
        bars: 2, chords: 'G | G', bass: { bass: '1 . 8 1 . 8 5 .', u: 2 },
        arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 4, inst: 'chip' },
        drums: { h: 'x.x.x.x.x.x.x.x.' }, fill: { s: '........x.x.xxxx' },
      },
      A: {
        bars: 8, chords: 'G | G | C | D | Em | C | Am D | G',
        lead: `d5 g5 b5 g5 d6 - b5 - | a5 b5 g5 - d5 - - - | e5 g5 c6 g5 e6 - c6 - | d6 c6 a5 - f#5 - a5 - |
               b5 - g5 b5 e6 - d6 b5 | c6 - g5 c6 e6 - d6 c6 | a5 c6 e6 - d6 c6 a5 f#5 | g5 - - - . . d5 .`,
        bass: { bass: '1 . 8 1 . 8 5 .', u: 2 },
        arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 4, inst: 'chip', v: 0.8 },
        pad: { pad: true, v: 0.8 },
        drums: { k: 'x.....x...x.....', s: '....x.......x...', h: 'x.x.x.x.x.x.x.x.' },
      },
      B: {
        bars: 8, chords: 'Em | D | C | G/B | Am | C | D | D',
        lead: `e6 - b5 - g5 - b5 - | d6 - a5 - f#5 - a5 - | c6 - g5 - e5 - g5 c6 | b5 - d6 - g6 - - - |
               a5 b5 c6 b5 a5 - e5 - | c6 d6 e6 d6 c6 - g5 - | d6 - f#6 - a6 - f#6 - | d6 - - - a5 b5 c6 d6`,
        bass: { bass: '1 . 1 8 . 1 5 8', u: 2 },
        arp: { arp: '0 1 2 3 2 1 2 3', u: 1, oct: 4, inst: 'chip', v: 0.8 },
        pad: { pad: true, v: 0.9 },
        drums: { k: 'x.....x.x.....x.', s: '....x.......x...', h: 'x.xxx.xxx.xxx.xx' },
        fill: { s: '....x.......xxxx', m: '........x.x.....' },
      },
    },
    order: ['I', 'A', 'A', 'B'], loop: 1,
  };

  // World 2 - Dependency Depths: a swung, slightly shady groove
  S.w2 = {
    bpm: 112, swing: 0.14,
    inst: { lead: 'thin', bass: 'sbass' },
    sections: {
      I: {
        bars: 2, chords: 'Em | Em', bass: { bass: '1 . . 1 . . 8 . 1 . 7 . 8 . 5 .', u: 1 },
        drums: { k: 'x..x..x...x.x...', h: 'x.xxx.xxx.xxx.xx' }, fill: { s: '....x.......x.xx' },
      },
      A: {
        bars: 8, chords: 'Em | Em | C | D | Em | Em | Am | B7',
        lead: `e5 . g5 a5 b5 - a5 g5 | e5 . . . b4 d5 e5 . | e5 . g5 a5 c6 - b5 g5 | a5 - f#5 - d5 . . . |
               e5 . g5 a5 b5 - d6 b5 | e6 - d6 b5 a5 g5 e5 . | a5 . c6 . e6 - c6 a5 | b5 - a5 - f#5 d#5 b4 .`,
        bass: { bass: '1 . . 1 . . 8 . 1 . 7 . 8 . 5 .', u: 1 },
        organ: { stab: '..x...x...x..x..', u: 1, oct: 4, len: 1, inst: 'organ' },
        drums: { k: 'x..x..x...x.x...', s: '....x.......x...', c: '....x.......x...', h: 'x.xxx.xxx.xxx.xx' },
      },
      B: {
        bars: 8, chords: 'C | D | Em | Em | C | D | B7 | B7',
        lead: `g5 - e5 g5 c6 - - - | a5 - f#5 a5 d6 - - - | b5 - g5 b5 e6 - d6 b5 | g5 - e5 - . . . . |
               c6 - g5 c6 e6 - - - | d6 - a5 d6 f#6 - - - | f#6 - d#6 - b5 - a5 - | f#5 - a5 - b5 - d#6 -`,
        bass: { bass: '1 . . 1 . 8 . 1 . . 1 . 8 . 5 .', u: 1 },
        organ: { stab: 'x..x..x...x..x..', u: 1, oct: 4, len: 1, inst: 'organ' },
        pad: { pad: true, v: 0.8 },
        drums: { k: 'x..x..x...x.x...', s: '....x.......x...', c: '....x.......x...', h: 'x.xxx.xxx.xxx.xx', o: '..............x.' },
        fill: { s: '....x.....x.xxxx' },
      },
    },
    order: ['I', 'A', 'A', 'B'], loop: 1,
  };

  // World 3 - The Heap: slow, glassy, a long way underground
  S.w3 = {
    bpm: 92,
    inst: { lead: 'bell', bass: 'sub' },
    sections: {
      A: {
        bars: 8, chords: 'Am | Am | Fmaj7 | Fmaj7 | Dm7 | Dm7 | Esus4 | E',
        lead: `e5 - - a5 - - b5 c6 | b5 - - e5 - - - - | e5 - - a5 - - c6 e6 | d6 - c6 - a5 - - - |
               f5 - - a5 - - c6 d6 | c6 - a5 - f5 - - - | e5 - a5 - b5 - e6 - | g#5 - - - b5 - g#5 -`,
        twinkle: { arp: '0 . 2 . 3 . 2 . 4 . 2 . 3 . 2 .', u: 1, oct: 4, inst: 'glass', v: 0.5 },
        bass: { bass: '1 - - - - - . 1', u: 2 },
        pad: { pad: true, v: 1.1 },
        drums: { k: 'x.........x.....', r: '........x.......', h: '..o...o...o...o.', t: '......x.......o.' },
      },
      B: {
        bars: 8, chords: 'C | G/B | Am | Am | F | G | Am | E',
        lead: `g5 - e5 g5 c6 - - - | b5 - g5 b5 d6 - - - | c6 - b5 a5 e5 - - - | . . a4 c5 e5 a5 c6 e6 |
               f6 - e6 c6 a5 - - - | g6 - d6 b5 g5 - - - | a5 - c6 - e6 - a6 - | g#6 - - e6 - - b5 -`,
        twinkle: { arp: '0 2 3 2 4 2 3 2', u: 2, oct: 4, inst: 'glass', v: 0.5 },
        bass: { bass: '1 - - 1 - - 5 -', u: 2 },
        pad: { pad: true, v: 1.1 },
        arp: { arp: '0 1 2 1', u: 1, oct: 5, inst: 'chip', v: 0.35 },
        drums: { k: 'x.....x...x.....', r: '....x.......x...', h: 'x.o.x.o.x.o.x.o.' },
      },
    },
    order: ['A', 'B'], loop: 0,
  };

  // World 4 - Thread Tower: clockwork, never quite at rest
  S.w4 = {
    bpm: 144,
    inst: { bass: 'sbass' },
    sections: {
      A: {
        bars: 8, chords: 'Cm | Cm | Ab | G | Cm | Cm | Fm | G',
        lead: `c5 eb5 g5 c6 g5 eb5 g5 - | d5 eb5 d5 c5 g4 - - - | c5 eb5 ab5 c6 ab5 eb5 ab5 - | b4 d5 g5 b5 d6 - b5 g5 |
               c6 - g5 eb6 - d6 c6 - | g5 - eb5 c6 - bb5 g5 - | f5 ab5 c6 f6 - eb6 c6 ab5 | g5 b5 d6 g6 - f6 d6 b5`,
        bass: { bass: '1 1 8 1 1 8 1 5', u: 2 },
        arp: { arp: '0 2 1 2', u: 1, oct: 4, inst: 'chip', v: 0.6 },
        drums: { k: 'x.......x..x....', s: '....x.......x...', h: 'x.xxx.xxx.xxx.xx', t: 'x...x...x...x...', T: '..x...x...x...x.' },
      },
      B: {
        bars: 8, chords: 'Ab | Bb | Cm | Cm | Ab | Bb | G | G',
        lead: `eb6 - c6 ab5 eb6 - c6 ab5 | f6 - d6 bb5 f6 - d6 bb5 | g6 - eb6 c6 g5 - c6 eb6 | d6 - c6 - g5 - - - |
               c6 - ab5 eb5 c6 - ab5 eb5 | d6 - bb5 f5 d6 - bb5 f5 | d6 - b5 g5 d5 g5 b5 d6 | g6 - - - f6 d6 b5 g5`,
        bass: { bass: '1 . 1 8 1 . 8 1', u: 2 },
        pad: { pad: true, v: 1 },
        organ: { stab: '..x..x....x..x..', u: 1, oct: 4, len: 1, inst: 'organ' },
        drums: { k: 'x.....x.x..x....', s: '....x.......x...', h: 'x.xxx.xxx.xxx.xx', t: 'x...x...x...x...', T: '..x...x...x...x.' },
        fill: { s: '....x...x.x.xxxx' },
      },
    },
    order: ['A', 'A', 'B'], loop: 0,
  };

  // World 5 - Production: everything is on fire
  S.w5 = {
    bpm: 168,
    inst: { bass: 'sbass' },
    sections: {
      A: {
        bars: 8, chords: 'Am | Am | Bb | Am | Am | Am | F | E',
        lead: `a5 - e5 a5 c6 - b5 a5 | e6 - - c6 a5 - e5 - | bb5 - f5 bb5 d6 - c6 bb5 | a5 - e5 - c5 e5 a5 - |
               a5 c6 e6 a6 e6 c6 a5 c6 | b5 c6 b5 a5 e5 - - - | f5 a5 c6 f6 - e6 c6 a5 | e6 - g#5 b5 e6 - g#6 -`,
        bass: { bass: '1 1 1 8 1 1 8 1 1 1 1 8 1 1 8 1', u: 1 },
        stab: { stab: 'x..x..x...x..x..', u: 1, oct: 4, len: 1 },
        drums: { k: 'x.....x...x..x..', s: '....x.......x...', h: 'x.x.x.x.x.x.x.x.', o: '..............x.' },
      },
      B: {
        bars: 8, chords: 'Dm | Dm | Am | Am | Bb | Bb | E | E',
        lead: `d6 - a5 f6 - e6 d6 - | a5 - f5 d6 - c6 a5 - | c6 - a5 e6 - d6 c6 - | a5 - e5 a5 . . . . |
               bb5 d6 f6 bb6 - a6 f6 d6 | bb5 - d6 - f6 - - - | e6 e6 . e6 e6 . e6 e6 | g#6 - - - e6 b5 g#5 e5`,
        bass: { bass: '1 1 8 1 1 8 1 1 8 1 1 8 1 1 8 8', u: 1 },
        stab: { stab: 'x..x..x.x..x..x.', u: 1, oct: 4, len: 1 },
        pad: { pad: true },
        drums: { k: 'x..x..x...x..x..', s: '....x.......x...', h: 'xxxxxxxxxxxxxxxx' },
        fill: { s: '....x..x.x.xxxxx' },
      },
    },
    order: ['A', 'A', 'B'], loop: 0,
  };

  // Boss fights
  S.boss = {
    bpm: 160,
    inst: { bass: 'sbass' },
    sections: {
      A: {
        bars: 8, chords: 'Dm | Dm | Bb | C | Dm | Dm | Bb | A',
        lead: `d5 - a5 - d6 - c6 a5 | c6 a5 f5 a5 d5 - . . | d5 - bb5 - d6 - c6 bb5 | c6 - g5 e5 c6 - e6 - |
               f6 - e6 d6 a5 - d6 - | f6 - e6 d6 a5 - f5 - | bb5 - d6 - f6 - d6 bb5 | a5 - c#6 - e6 - a6 -`,
        bass: { bass: '1 . 1 1 8 . 1 1 . 1 8 . 1 1 8 1', u: 1 },
        stab: { stab: 'x..x..x.x..x..x.', u: 1, oct: 4, len: 1 },
        arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 5, inst: 'chip', v: 0.7, hi: 1 },
        drums: { k: 'x.....x.x.x.....', s: '....x.......x...', h: 'x.x.x.x.x.x.x.x.', hi: { h: '.x.x.x.x.x.x.x.x' } },
      },
      B: {
        bars: 8, chords: 'Gm | A | Dm | Dm/C | Bb | C | A | A',
        lead: `g5 bb5 d6 g6 - f6 d6 bb5 | a5 c#6 e6 a6 - g6 e6 c#6 | d6 - f6 - a6 - f6 d6 | c6 - a5 - f5 - d5 - |
               bb5 d6 f6 bb6 - a6 f6 d6 | c6 e6 g6 c7 - bb6 g6 e6 | a6 - e6 c#6 a5 - e5 c#5 | a4 c#5 e5 a5 c#6 e6 a6 -`,
        bass: { bass: '1 1 8 1 1 8 1 8', u: 2 },
        stab: { stab: 'x.x..x.x.x..x.x.', u: 1, oct: 4, len: 1 },
        pad: { pad: true },
        arp: { arp: '0 1 2 3 2 1 0 1', u: 1, oct: 5, inst: 'chip', v: 0.7, hi: 1 },
        drums: { k: 'x..x..x.x..x..x.', s: '....x.......x...', h: 'xxxxxxxxxxxxxxxx' },
        fill: { s: '....x..x.x.xxxxx', m: '..........x.x...' },
      },
    },
    order: ['A', 'A', 'B'], loop: 0,
  };

  // The Monolith: the main theme, bent into D minor
  S.final = {
    bpm: 150,
    inst: { bass: 'sbass' },
    sections: {
      A: {
        bars: 8, chords: 'Dm | A/C# | Bb | Gm | Dm | A | Gm | A',
        lead: `f5 - a5 - d6 - c6 a5 | bb5 - a5 - e5 - - - | d5 - f5 - bb5 - a5 f5 | g5 - f5 - d5 - - - |
               f5 - a5 - d6 - e6 f6 | e6 - c#6 - a5 - b5 c#6 | d6 - bb5 - g5 - bb5 - | a5 - - - c#6 - e6 -`,
        bass: { bass: '1 1 8 1 1 8 1 1', u: 2 },
        pad: { pad: true, v: 1.2 },
        stab: { stab: '..x..x....x..x..', u: 1, oct: 4, len: 1 },
        arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 5, inst: 'chip', v: 0.7, hi: 1 },
        drums: { k: 'x.....x.x.......', s: '....x.......x...', h: 'x.x.x.x.x.x.x.x.', m: '..............x.' },
      },
      B: {
        bars: 8, chords: 'Dm | Dm | C | C | Bb | Bb | A | A',
        lead: `d6 - d6 a5 d6 - f6 - | e6 - d6 - a5 - - - | c6 - c6 g5 c6 - e6 - | d6 - c6 - g5 - - - |
               bb5 - bb5 f5 bb5 - d6 - | c6 - bb5 - f5 - d6 f6 | e6 - c#6 a5 e6 - c#6 a5 | a5 c#6 e6 a6 - - . .`,
        bass: { bass: '1 . 1 1 8 . 1 1 . 1 8 . 1 1 8 1', u: 1 },
        stab: { stab: 'x..x..x.x..x..x.', u: 1, oct: 4, len: 1 },
        arp: { arp: '0 1 2 3 2 1 0 1', u: 1, oct: 5, inst: 'chip', v: 0.7, hi: 1 },
        drums: { k: 'x..x..x.x..x..x.', s: '....x.......x...', h: 'xxxxxxxxxxxxxxxx' },
        fill: { s: '....x..x.x.xxxxx' },
      },
    },
    order: ['A', 'B'], loop: 0,
  };
  // ...and back into D major for the last stretch
  S.final2 = {
    bpm: 156,
    sections: {
      A: {
        bars: 8, chords: CH_A, pad: { pad: true, v: 1.2 },
        lead: { n: THEME_A }, dbl: { n: THEME_A, inst: 'soft', v: 0.7 },
        bass: { bass: '1 1 8 1 1 8 1 8', u: 2, inst: 'sbass' },
        stab: { stab: 'x..x..x.x..x..x.', u: 1, oct: 4, len: 1 },
        arp: { arp: '0 2 1 2 3 2 1 2', u: 1, oct: 5, inst: 'chip', v: 0.7 },
        drums: { k: 'x..x..x.x..x..x.', s: '....x.......x...', h: 'xxxxxxxxxxxxxxxx' },
      },
      B: {
        bars: 8, chords: CH_B, pad: { pad: true, v: 1.2 },
        lead: { n: THEME_B, oct: 1 }, dbl: { n: THEME_B, inst: 'soft', v: 0.7, oct: 1 },
        bass: { bass: '1 1 8 1 1 8 5 8', u: 2, inst: 'sbass' },
        stab: { stab: 'x.x..x.x.x..x.x.', u: 1, oct: 4, len: 1 },
        arp: { arp: '0 1 2 3 2 1 0 1', u: 1, oct: 5, inst: 'chip', v: 0.7 },
        drums: { k: 'x..x..x.x..x..x.', s: '....x.......x...', h: 'xxxxxxxxxxxxxxxx' },
        fill: { s: '....x..x.x.xxxxx' },
      },
    },
    order: ['A', 'B'], loop: 0,
  };

  // before a boss speaks
  S.tension = {
    bpm: 96,
    sections: {
      A: {
        bars: 4, chords: 'Dm | Dm | Bbmaj7 | A',
        pad: { pad: true, oct: 2, v: 1.6 },
        bass: { bass: '1 - - - - - - -', u: 2, inst: 'sub' },
        twinkle: { arp: '. . . . 2 . . . . . . . 1 . . .', u: 1, oct: 5, inst: 'glass', v: 0.5 },
        drums: { k: 'x..o............', t: '....x.......x...' },
      },
    },
    order: ['A'], loop: 0,
  };

  // jingles
  S.clear = {
    bpm: 150, once: true,
    sections: {
      A: {
        bars: 3, chords: 'D | G A | D',
        lead: { n: 'd4 f#4 a4 d5 f#5 - - - . . e5 - f#5 - - - | g5 - - - f#5 - g5 - a5 - - - - - - - | d6 - - - - - - - - - - - . . . .', u: 1 },
        dbl: { n: 'a3 d4 f#4 a4 d5 - - - . . c#5 - d5 - - - | d5 - - - d5 - d5 - e5 - - - - - - - | f#5 - - - - - - - - - - - . . . .', u: 1, inst: 'soft' },
        bass: { bass: '1 . 1 . 1 . 8 .', u: 2 }, pad: { pad: true },
        drums: { k: 'x...x...x...x...x...x...x.x.x.x.x...............', s: '........x.......x.......x.xxxxxx................', C: '................................x...............' },
      },
    },
    order: ['A'],
  };
  S.toolget = {
    bpm: 132, once: true,
    sections: {
      A: {
        bars: 3, chords: 'G C | D | G',
        bell: { n: 'g4 b4 d5 g5 b5 - d6 - c6 - e6 - g6 - - - | f#6 - a6 - d6 - f#6 - a6 - - - - - - - | g6 - - - - - - - - - - - . . . .', u: 1, inst: 'bell' },
        lead: { n: 'g4 b4 d5 g5 b5 - d6 - c6 - e6 - g6 - - - | f#6 - a6 - d6 - f#6 - a6 - - - - - - - | g6 - - - - - - - - - - - . . . .', u: 1, inst: 'soft', v: 0.6 },
        bass: { bass: '1 - - - 1 - - -', u: 2 }, pad: { pad: true, v: 1.3 },
        drums: { C: '................................x...............' },
      },
    },
    order: ['A'],
  };
  S.gameover = {
    bpm: 84, once: true,
    sections: {
      A: {
        bars: 2, chords: 'Dm | A',
        bell: { n: 'd5 - c5 - bb4 - a4 - | - - - - . . . .', inst: 'bell' },
        bass: { bass: '1 - - - - - - -', u: 2, inst: 'sub' }, pad: { pad: true, v: 1.2 },
      },
    },
    order: ['A'],
  };
})();

